
    import "/home/git/waysglob/website/src/components/news-events-items-group/index.module.scss.FARM_CSS_MODULES?205d194e";
    
    export default {"items-wrapper": `items-wrapper-8b668384`,"more": `more-8b668384`,"wrapper": `wrapper-8b668384`,"title-wrapper": `title-wrapper-8b668384`}
    